var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pd70"},[(!_vm.isPage('detail'))?_c('Nav'):_vm._e(),_vm._v(" "),_c('keep-alive',[_c('a-locale-provider',{attrs:{"locale":_vm.zh_CN}},[(_vm.RouterShow)?_c('router-view'):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9d9186ac","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/todoCenter/default/wechat/layout/index.vue
// module id = null
// module chunks = 